import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const LeagueTeamSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"League Team Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Name",
                                key: "name",
                            },
                            {
                                label: "Short Name",
                                key: "shortName",
                            },
                            {
                                label: "City",
                                key: "city",
                            },
                        ]}
                        columnB={[
                            {
                                label: "Coach",
                                key: "coach",
                            },
                            {
                                label: "Manager",
                                key: "manager",
                                format: "ModelLink",
                            },
                        ]}
                        columnC={[
                            {
                                label: "Logo",
                                key: "logo",
                                format: "image",
                                filters: {
                                    width: 100
                                }
                            },
                            {
                                label: "Created By",
                                key: "created",
                                format: "OnAndBy",
                            }
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default LeagueTeamSingleView;
